import React from "react";
import PropTypes from "prop-types";
import ExtraItemsNotice from "../../../components/delivery/ExtraItemsNotice";

// Read-only view of an order's "Meds to Pack Separately" note, opened from a delivery row.
//
// The note lives on the ORDER (userOrders.additionalDetails.extraItems) and is written on
// the order edit page. Deliveries carry it through because Delivery.Get includes userOrders
// without restricting attributes — no backend change was needed.
//
// Read-only deliberately: this is a packing instruction from the pharmacist, and the
// logistics console is the consumer, not the author. Editing happens where it is written.
function DeliveryExtraItemsModal({ delivery, onClose }) {
    const extraItems = delivery?.userOrder?.additionalDetails?.extraItems;

    return (
        <div className="flex flex-col gap-[0.9rem] min-w-[420px]">
            <div className="flex justify-between items-center">
                <span className="text-[1.5rem] font-bold">Extra Items</span>
                <span className="text-[1.2rem]">
                    Order ID:{" "}
                    <span className="text-[1.2rem] font-semibold">{`#${delivery?.userOrderId ?? "—"}`}</span>
                </span>
            </div>
            <hr />

            <ExtraItemsNotice extraItems={extraItems} />

            <p className="text-sm text-gray-500">
                Written by the pharmacist on the order. Edit it from the order edit page.
            </p>

            <div className="flex justify-end">
                <button
                    type="button"
                    onClick={onClose}
                    className="px-5 py-2 rounded-xl border border-gray-300 text-[1.2rem] font-semibold text-gray-700 hover:bg-gray-50"
                >
                    Close
                </button>
            </div>
        </div>
    );
}

DeliveryExtraItemsModal.propTypes = {
    delivery: PropTypes.object,
    onClose: PropTypes.func.isRequired,
};

export default DeliveryExtraItemsModal;
